<template>
  <div class="request-submitted">
    <h1 v-translate>You've successfully submitted your grant request.</h1>
    <p v-translate>You can view and edit your request in the My Activity section.</p>
    <p v-if="!organizationDetails.eventDocumentationEnabled && !organizationDetails.expenseDocumentationEnabled" v-translate>
      We'll review your request and reply to you within two business days. If your request is
      approved, we'll notify you and send your grant funds to the PayPal account associated with the
      email address you provided in your request. If we need additional information
      from you in order to process your grant request, we will let you know.
    </p>
    <p v-if="organizationDetails.eventDocumentationEnabled || organizationDetails.expenseDocumentationEnabled" v-translate>
      We'll review your request and reply to you within two business days. If your request is
      approved, we'll notify you and send your grant funds to the PayPal account associated with the
      email address you provided in your request. If we need additional information or documentation
      from you in order to process your grant request, we will let you know.
    </p>
    <p>
      <translate>If you have more questions about how grant requests work, see the</translate>
      <router-link to="FAQ"><span>&nbsp;</span><span v-translate>FAQ</span></router-link
      >.
    </p>
    <NavigationBox
      v-if="organizationDetails.springFourEnabled"
      title="Additional help is just a click away!"
      description="Connect with local resources that provide financial assistance. Save on groceries, utilities, and prescriptions; access financial counseling; and more."
      @click="onClickFinancialResources"
      style="margin: 2rem 0;"
    />
    <md-button @click="onSubmitRequest" class="button">
      <span v-translate class="inherit-font">Home</span>
    </md-button>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import NavigationBox from '@/components/NavigationBox'
import { analyticsMixin } from '@/services/googleAnalytics'
export default {
  name: 'RequestSubmitted',
  mixins: [analyticsMixin],
  components: {
    NavigationBox,
  },
  methods: {
    onSubmitRequest() {
      this.$router.push({ name: 'Home' })
    },
    onClickFinancialResources() {
      this.eventsTracker('clicked-cta-resources')
      this.$router.push({ name: 'FindResources' })
    },
  },
  computed: mapState(['organizationDetails']),
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables';
@import '@/styles/mixins/buttons';
@import '@/styles/mixins/containers';
.request-submitted {
  @include screen-container();
}
.button {
  @include primary-button(var(--dark-brand-color));
  margin: 2rem;
}
p {
  margin: 1rem 0;
}
</style>
